module.exports = __webpack_public_path__ + "img/changzhi-3898da.png";